import { getUserInfo } from '@/domain/account/api';
import { useQuery } from '@tanstack/react-query';

export const useUserInfo = (enabled = true) =>
  useQuery({
    queryKey: ['user'],
    queryFn: getUserInfo,
    staleTime: 1000 * 60 * 15,
    enabled,
  });
